import React from 'react'
import PropTypes from 'prop-types'
import Helmet from '../components/Helmet';
import MainHeader from '../components/MainHeader';
import HeroLinks from '../components/Hero/HeroLinks';
import { PFR } from '../components/PFR';

import './index.scss'
import './layout.scss'

const Layout = ({ children, data }) => (
  <main className="app">
    <Helmet
      title="Strona główna"
      meta={[
        { name: 'description', content: 'CustomArt to agencja artystyczna wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.' },
      ]}
    />
    <MainHeader />
    {children()}
    <PFR />
    <HeroLinks />
  </main>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js